<template>
  <div class="flex max-h-fit flex-col gap-4 rounded-sm border border-main bg-surface-elevation-1 p-4 text-main">
    <div class="txt-headline-m">
      {{ t('Reviews.product.campaign.campaignLimitPreviewBox.title') }}
    </div>
    <div class="text-body-m">
      <div class="ml-5">{{ previewData.textLine1 }}</div>
      <div class="flex items-center gap-1">
        <component :is="previewData.icon" class="lucide-icon-s" />
        <span>{{ previewData.textLine2 }}</span>
      </div>
    </div>
    <div class="flex items-center gap-1 txt-headline-m"><EqualIcon class="lucide-icon-s" />{{ previewData.outcome }}</div>
  </div>
</template>

<script setup lang="ts">
import { XIcon, DivideIcon, EqualIcon } from '@ramp106/omrjs-core-ui/icons'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { IncentivizationCampaignLimitTypeEnum, IncentivizationCampaignIncentivizationTypeEnum } from '@/gql/reviews'

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    incentiveAmount: number
    incentivizationType: IncentivizationCampaignIncentivizationTypeEnum
    incentivizationsLimit?: number
    budgetLimit?: number
    variant: IncentivizationCampaignLimitTypeEnum
  }>(),
  {
    incentivizationsLimit: 0,
    budgetLimit: 0,
  },
)

const previewData = computed(() => {
  const textLine2 = t(`Reviews.product.campaign.campaignLimitPreviewBox.incentiveAmount.${props.incentivizationType}`, {
    amount: props.incentiveAmount,
  })
  if (props.variant === IncentivizationCampaignLimitTypeEnum.Incentivizations) {
    return {
      icon: XIcon,
      textLine1: t('Reviews.product.campaign.campaignLimitPreviewBox.publishedReviews', { number: props.incentivizationsLimit ?? 0 }),
      textLine2,
      outcome: t('Reviews.product.campaign.campaignLimitPreviewBox.totalCosts', {
        amount: props.incentiveAmount * props.incentivizationsLimit,
      }),
    }
  } else {
    return {
      icon: DivideIcon,
      textLine1: t('Reviews.product.campaign.campaignLimitPreviewBox.budgetLimit', { amount: props.budgetLimit ?? 0 }),
      textLine2,
      outcome: t('Reviews.product.campaign.campaignLimitPreviewBox.reviews', {
        amount: Math.floor(props.budgetLimit / props.incentiveAmount),
      }),
    }
  }
})
</script>
